import React, { useEffect, useState } from 'react';
import { Row, Col, Typography, Input, Button, Select, message, Form } from 'antd';
import { CopyOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { AddUpdatedEmail, getEmail } from '../../redux/OmniChannels/OmniChannelsActions';

const { Title, Text } = Typography;

const EmailConfigration = () => {
    const [form] = Form.useForm();
    const [secretTokenVisible, setSecretTokenVisible] = useState(false);
    const [secretTokenVisiblee, setSecretTokenVisiblee] = useState(false);
    const userData = useSelector((state) => state.Auth.userData);
    const { loading_email, emailData } = useSelector((state) => state.OmniChannelsReducer);
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(getEmail({ companyId: userData?.companyId }));
    }, []);

    const handleSubmit = (values) => {
        let newData = {
            ...values,
            companyId: userData?.companyId
        }
        dispatch(AddUpdatedEmail(newData))
    };

    useEffect(() => {
        if (emailData) {
            form.setFieldsValue({
                host: emailData?.host,
                port: emailData?.port,
                user: emailData?.user,
                pass: emailData?.pass,
                receive_host: emailData?.receive_host,
                receive_port: emailData?.receive_port,
                receive_user: emailData?.receive_user,
                receive_pass: emailData?.receive_pass,
                receive_tls: emailData?.receive_tls
            });
        }
    }, [emailData, form]);

    return (
        <div style={{ padding: 24, background: '#fff', borderRadius: 12 }}>
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
            >
                <Row gutter={32}>

                    {/* LEFT SIDE */}
                    <Col xs={24} md={12}>
                        <Title level={4}>Sent Email Configuration</Title>


                        <Form.Item
                            label="Host"
                            name="host"
                            rules={[{ required: true, message: 'Please input your host' }]}
                        >
                            <Input.Password
                                iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                }
                                onClick={() => setSecretTokenVisiblee(!secretTokenVisiblee)}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Port"
                            name="port"
                            rules={[{ required: true, message: 'Please input your port' }]}
                        >
                            <Input type='number' placeholder="Enter port" />
                        </Form.Item>

                        <Form.Item
                            label="User"
                            name="user"
                            rules={[{ required: true, message: 'Please input your User' }]}
                        >
                            <Input type='text' placeholder="User" />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="pass"
                            rules={[{ required: true, message: 'Please input your Password' }]}
                        >
                            <Input.Password
                                iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                }
                                onClick={() => setSecretTokenVisible(!secretTokenVisible)}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Title level={4}>Receive Email Configuration</Title>


                        <Form.Item
                            label="Receive Host"
                            name="receive_host"
                            rules={[{ required: true, message: 'Please input your Receive host' }]}
                        >
                            <Input.Password
                                placeholder="Enter Receive Host"
                                iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                }
                                onClick={() => setSecretTokenVisiblee(!secretTokenVisiblee)}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Receive Port"
                            name="receive_port"
                            rules={[{ required: true, message: 'Please input your Receive port' }]}
                        >
                            <Input type='number' placeholder="Enter Receive port" />
                        </Form.Item>

                        <Form.Item
                            label="Receive User"
                            name="receive_user"
                            rules={[{ required: true, message: 'Please input your  Receive User' }]}
                        >
                            <Input type='text' placeholder="Receive User" />
                        </Form.Item>

                        <Form.Item
                            label="Receive Password"
                            name="receive_pass"
                            rules={[{ required: true, message: 'Please input your Receive Password' }]}
                        >
                            <Input.Password
                                placeholder="Receive Password"
                                iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                }
                                onClick={() => setSecretTokenVisible(!secretTokenVisible)}
                            />
                        </Form.Item>

                        <Form.Item
                            name="receive_tls"
                            label="Enable TLS Encryption"
                            rules={[{ required: true, message: 'Please select TLS option' }]}
                        >
                            <Select
                                placeholder="Select TLS option"
                                optionFilterProp="children"
                                allowClear={false}
                            >
                                <Select.Option value={true}>
                                    <span style={{ color: '#52c41a' }}>Enabled (True)</span>
                                </Select.Option>
                                <Select.Option value={false}>
                                    <span style={{ color: '#ff4d4f' }}>Disabled (False)</span>
                                </Select.Option>
                            </Select>
                        </Form.Item>


                        <Form.Item>
                            <Button disabled={loading_email} type="primary" htmlType="submit">
                                Submit Config
                            </Button>
                        </Form.Item>

                    </Col>

                </Row >
            </Form>
        </div >
    );
};

export default EmailConfigration;
